module.exports = __webpack_public_path__ + "static/media/blue-loader.27661f27.svg";